var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page_wrapper" }, [
    _c("header", { staticClass: "header" }, [
      _c("nav", { staticClass: "navbar navbar-inverse navbar-fixed-top" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c(
            "div",
            {
              staticClass: "navbar-header",
              class: _vm.areaExpanded ? "fl-left" : "",
            },
            [
              _c(
                "router-link",
                { staticClass: "logo", attrs: { to: "/", title: "Logo" } },
                [
                  _c("img", {
                    staticClass: "hide-xs",
                    attrs: {
                      id: "logo",
                      alt: "logo",
                      src: "/static/images/logos/RAMS_Logo.svg",
                    },
                  }),
                  _c("img", {
                    staticClass: "show-xs",
                    attrs: {
                      id: "logo",
                      alt: "logo",
                      src: "/static/images/logos/RAMS_Mobile_Logo.svg",
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "display_xs collapsed",
              attrs: {
                id: "burger_menu",
                type: "button",
                "aria-expanded": "false",
                "data-toggle": "collapse",
                "data-target": "#NavBar_DropDown",
              },
              on: {
                click: function ($event) {
                  _vm.areaExpanded = !_vm.areaExpanded
                },
              },
            },
            [
              _c("div", { staticClass: "x" }),
              _c("div", { staticClass: "y" }),
              _c("div", { staticClass: "z" }),
            ]
          ),
          _c("ul", { staticClass: "nav navbar-nav hide_xs" }, [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "rams-terms",
                    attrs: { to: "/terms-of-service" },
                  },
                  [_vm._v("RAMS SaaS Agreement")]
                ),
              ],
              1
            ),
            _vm._m(0),
            _vm._m(1),
            _c(
              "li",
              { staticClass: "mr-rt-24" },
              [
                _c(
                  "router-link",
                  { staticClass: "btn button_login", attrs: { to: "/login" } },
                  [_vm._v("Log In")]
                ),
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn emergo-green-button",
                    attrs: { to: "/register" },
                  },
                  [_vm._v("Sign Up")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "ul",
            {
              staticClass: "nav navbar-nav collapse",
              attrs: { id: "NavBar_DropDown", "aria-expanded": "false" },
            },
            [
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      "data-toggle": "collapse",
                      "data-target": "#NavBar_DropDown",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.redirect("/login")
                      },
                    },
                  },
                  [_vm._v("Log In")]
                ),
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      "data-toggle": "collapse",
                      "data-target": "#NavBar_DropDown",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.redirect("/register")
                      },
                    },
                  },
                  [_vm._v("Sign Up")]
                ),
              ]),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      "data-toggle": "collapse",
                      "data-target": "#NavBar_DropDown",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.redirect("/terms-of-service")
                      },
                    },
                  },
                  [_vm._v("RAMS SaaS Agreement ")]
                ),
              ]),
              _vm._m(2),
              _vm._m(3),
            ]
          ),
        ]),
      ]),
    ]),
    _c(
      "main",
      { staticClass: "subpage", class: _vm.areaExpanded ? "disp-none" : "" },
      [
        _c(
          "section",
          [
            _vm.showDialog === "true"
              ? _c("div", { staticClass: "china-login-box china-container" }, [
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.showDialog = "false"
                        },
                      },
                    },
                    [_vm._v("×")]
                  ),
                  _vm._m(4),
                  _vm._m(5),
                ])
              : _vm._e(),
            _c("router-view"),
            _vm.banners && _vm.banners.length
              ? _c(
                  "div",
                  { staticClass: "flex-container container banner-container" },
                  [
                    _c("notification-banner", {
                      attrs: { notification: _vm.banners[0] },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "col-sm-12 flex-container security_logos mb-10",
        class: _vm.areaExpanded ? "disp-none" : "",
      },
      [_vm._m(6)]
    ),
    _c("footer", { class: _vm.areaExpanded ? "disp-none" : "" }, [
      _c("nav", { staticClass: "footer_content" }, [
        _c("ul", { staticClass: "footer-copyright" }, [
          _c("li", [
            _vm._v(
              "© " +
                _vm._s(_vm.getFullYear()) +
                " EMERGO by UL. All rights reserved."
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c(
        "a",
        {
          staticClass: "rams-terms",
          attrs: {
            href: "https://www.emergobyul.com/terms-of-use?action",
            target: "_blank",
          },
        },
        [_vm._v("Emergo by UL Terms of Use")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c(
        "a",
        {
          staticClass: "rams-terms pr-22",
          attrs: {
            href: "https://www.emergobyul.com/privacy-policy",
            target: "_blank",
          },
        },
        [_vm._v("Privacy Policy")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: "https://www.emergobyul.com/terms-of-use?action",
            target: "_blank",
          },
        },
        [_vm._v("Emergo by UL Terms of Use")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c(
        "a",
        {
          attrs: {
            href: " https://www.emergobyul.com/privacy-policy",
            target: "_blank",
          },
        },
        [_vm._v("Privacy Policy")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "table-container" }, [
      _c("div", [
        _c("img", {
          staticClass: "info-icon",
          attrs: {
            src: "/static/images/icons/info_icon_active.svg",
            alt: "info-icon",
          },
        }),
      ]),
      _c("div", [
        _c("h3", { staticClass: "text-emergo-dark-blue china-header" }, [
          _vm._v("China-based Customer?"),
        ]),
        _c("p", { staticClass: "china-content" }, [
          _vm._v(
            " If you are a user located in China, use this link to login/sign up for RAMS. "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "center" }, [
      _c(
        "a",
        {
          staticClass: "btn emergo-green-button",
          attrs: { href: "https://demo-rams.emergobyul.cn/" },
        },
        [_vm._v(" Access RAMS ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "disp-flex" }, [
      _c("img", {
        staticClass: "encrypt_logo",
        attrs: {
          src: "/static/images/logos/lets_encrypt.svg",
          alt: "encrypt-img",
        },
      }),
      _c("img", {
        staticClass: "azure_logo",
        attrs: {
          src: "/static/images/logos/microsoft_azure.svg",
          alt: "azure-img",
        },
      }),
      _c("div", { staticClass: "azure_security_logo-pt-5" }, [
        _c("img", {
          staticClass: "azure_security_logo",
          attrs: {
            src: "/static/images/logos/azr_security_logo.svg",
            alt: "security-img",
          },
        }),
        _c("span", { staticClass: "azure_security_text" }, [
          _vm._v("Azure Security Center"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }